import React from 'react';

/* eslint-disable react/jsx-filename-extension */

export default {
  common: {
    shortMode: 'Краткий режим',
    extendedMode: 'Расширенный режим',
    deleteButton: 'Удалить',
    cancelButton: 'Отмена',
    confirmDelete: 'Подтвердите удаление',
    closeButton: 'Закрыть',
    saveButton: 'Сохранить',
    saveAndContinueButton: 'Сохранить и продолжить',
    saveAndCloseButton: 'Сохранить и закрыть',
    editButton: 'Редактировать',
    calcButton: 'Рассчитать', //цель
    showBy: 'Показывать по',
    noData: 'Нет данных',
    forbidden: 'У вас недостаточно прав, авторизуйтесь',
    notFound1: 'Ничего не найдено',
    notFound2: 'Попробуйте вернуться назад или поищите что-нибудь другое.',
    notFound3: 'Код ошибки: 404',
    notFound4: 'На главную',
    editPhoto: 'Редактирование фото',
    back: 'Вернуться назад',
    loadPhoto: 'Загрузите фото',
    dropPhoto: 'Загрузите фото',
    mb: 'мб',
    sizeMax: 'Размер изображения не более',
    sizeMin: 'Размер изображения не менее 0 мб',
    format: 'Формат изображения jpg, jpeg, gif или png',
    quantity: 'Кол-во',
    maintenanceTitle: 'Технические работы',
    maintenanceDescription:
      'В настоящее время сервис недоступен из-за технических работ. Система автоматически проверяет состояние каждые 15 секунд. После восстановления соединения вы будете перенаправлены автоматически.',
    maintenanceRetryButton: 'Проверить сейчас',
  },
  accounts: {
    title: 'Счета / Активы / Обязательства',
    accounts: 'Счета',
    archiveAccounts: 'Архив счетов',
    cash: 'Наличные',
    bank: 'Банковские',
    broker: 'Брокерские',
    credit: 'Кредитные',
    insurance: 'Страховые',
    user: 'Пользовательские',
    addAccount: 'Добавить счёт',
    editAccount: 'Редактирование счёта',
    newAccount: 'Новый счёт',
    addActive: 'Добавить актив',
    editActive: 'Редактирование актива',
    newActive: 'Новый актив',
    addOblig: 'Добавить обязательство',
    editOblig: 'Редактирование обязательства',
    newOblig: 'Новое обязательство',
    actives: 'Активы',
    activesPrivate: 'Личные',
    activesInvest: 'Инвестиционные (не финансовые)',
    activesInvestTraded: 'Инвестиционные (торгуемые на бирже)',
    archiveActives: 'Архив активов',
    obligs: 'Обязательства',
    typeObligs: 'Тип обязательства',
    archiveObligs: 'Архив обязательств',
    currenctObligs: 'Текущие',
    longObligs: 'Долгосрочные',
    subAccounts: 'Субсчета',
    nameSubAccount: 'Название субсчёта',
    balance: 'Баланс',
    currency: 'Валюта',
    nameDeposit: 'Название депозита',
    descDeposit: 'Описание депозита',
    accountDeposit: 'Счет с которого внесён депозит',
    sumDeposit: 'Сумма депозита',
    startDeposit: 'Дата и время начала депозита',
    dataDeposit: 'Дата депозита',
    endDeposit: 'Дата и время завершения депозита',
    procentType: 'Тип процента',
    procentYear: 'Процент (годовых)',
    periodEarn: 'Период начисления',
    accountDepositEarn: 'Счет зачисления процентов',
    nameAccount: 'Название счёта',
    typeAccount: 'Тип счёта',
    bankName: 'Название банка',
    brokerName: 'Название брокера',
    addSubAccount: 'Добавить субсчет',
    temp: 'Временные',
    currencySum: 'Валюта суммы',
    deletingAccount: 'Удаление счёта',
    deleteAccount: 'Скрыть счёт',
    subAccount: 'Субсчёт',
    confirmDeleteAccount: 'Вы уверены что хотите скрыть счёт?',
    confirmDeleteSubAccount: 'Вы уверены что хотите удалить субсчёт?',
    typeActive: 'Тип актива',
    buyType: 'Способ приобретения актива',
    typeObject: 'Тип объекта',
    groupInvest: 'Группа инвестиции',
    name: 'Название',
    desc: 'Описание',
    buyActive: 'Покупка актива',
    getActive: 'Получение актива',
    buyAccount: 'Счёт покупки',
    debtAccount: 'Счёт списания',
    sumIn: 'Сумма довнесения',
    dateIn: 'Дата и время довнесения',
    sellActive: 'Продажа актива',
    sellAccount: 'Счёт продажи',
    sellPrice: 'Цена продажи',
    sellDate: 'Дата и время продажи',
    buyPrice: 'Цена покупки',
    buyDate: 'Дата и время покупки',
    valuePrice: 'Оценочная цена',
    getDate: 'Дата и время получения',
    addDeposit: 'Добавить депозит',
    depositNeedSubaccounts: 'Чтобы добавить депозит, сначала создайте хотя бы один субсчёт.',
    newInvest: 'Новая инвестиция',
    editInvest: 'Редактирование инвестиции',
    typeInvest: 'Тип инвестиции',
    tag: 'Тэг',
    classification: 'Классификация',
    addInvesting: 'Добавить инвестирование',
    activeName: 'Название актива',
    activeDesc: 'Описание',
    paymentSum: 'Сумма платежа',
    period: 'Периодичность',
    start: 'Дата и время начала',
    end: 'Дата и время завершения',
    newOperation: 'Новая операция',
    editOperation: 'Редактирование операции',
    confirm: 'Вы уверены что хотите удалить перевод?',
    transfer: 'Перевод между счетами',
    all: 'Итого',
    addSubaccount: 'Добавить субсчёт',
    current: 'Текущие',
    invest: 'Инвестиционные',
    other: 'Другое',
    brokerAccount: 'Брокерские счета',
    long: 'Долгосрочные',
    private: 'Личные',
    operations: 'Операции',
    operationAccount: 'Счёт операции',
    logsDate: 'Дата и время',
    logsAccount: 'Счёт',
    logsReason: 'Назначение платежа',
    logsSum: 'Сумма',
    logsCommission: 'Комиссия',
    logsBalance: 'Баланс',
  },
  dashboard: {
    incomesOutcomes: 'Бюджет',
    payments: 'Обязательства',
    paymentsPlan: (
      <>
        Обязательные платежи
        <br /> для соблюдения плана
      </>
    ),
    priceChange: 'Изменение стоимости активов',
    portfolio: 'Портфель',
    currentPriceActive: 'Текущая стоимость активов',
    avgPriceActive: 'Средняя стоимость активов',
    period: 'Период',
    inc: 'Дох.',
    outc: 'Расх.',
    actual: 'Реальные',
    planned: 'Плановые',
    values: 'Стоимость активов',
  },
  sidebar: {
    wealthy: 'Благосостояние',
    current: 'Текущие',
    invest: 'Инвестиционные',
    broker: 'Брокерс...',
    other: 'Другое',
    private: 'Личные',
    long: 'Долгосрочные',
    oblig: 'Обязательства',
    brokerAccount: 'Брокерские счета',
    insuranceAccount: 'Страховые счета',
    cash: 'Наличные',
    cards: 'На картах',
    user: 'Пользовательские счета',
    credit: 'Кредитные',
    actives: 'Активы',
    repoObligation: 'Обязательство по РЕПО',
  },
  menu: {
    dashboard: 'Дашборд',
    dynamic: 'Динамика состояния',
    accounts: (
      <>
        Счета /<br /> Активы /<br /> Обязательства
      </>
    ),
    operations: 'Операции',
    clients: 'Клиенты',
    fillProfile: 'Заполните профиль',
    incomes: 'Доходы',
    outcomes: 'Расходы',
    plan: 'Планирование',
    goals: 'Цели',
    charts: 'Графики',
    investList: 'Список инвестиций',
    repos: 'РЕПО',
    diagrams: 'Диаграммы',
    paymentsСalendar: 'Календарь выплат',
    view: 'Обзор',
    incomesOutcomes: 'Бюджет',
    planing: 'Планирование',
    invest: 'Инвестиции',
    robo: 'Робоэдвайзер',
    config: 'Настройки',
    support: 'Поддержка',
    profile: 'Профиль',
    logout: 'Выход',
    values: 'Стоимость активов',
  },
  mainPage: {
    title: 'Сервис для финансового учёта whiteswan (белый лебедь)',
    mainTitle: 'Сервис для персонального финансового планирования',
    mainTitle2: 'Платформа по контролю расходов<br/>и планированию сбережений',
    functions: 'Какие функции уже доступны в&nbsp;whiteswan (белый лебедь)',
    functions1: 'Ручной ввод доходов и расходов',
    functions2: 'Учет активов и обязательств',
    functions3: 'Планирование расходов и доходов',
    functions4: 'Расчёт финансовых целей',
    functions5: 'Учет финансовых и нефинансовых инвестиций',
    functions6: 'Визуализация инвестиционного портфеля финансовых целей',
    block1: 'Система скоринга финансового состояния',
    block11: 'Анализируй активы и обязательства',
    block12:
      'Структурируй активы по группам: текущие, инвестиционные, личного пользования. Проведи анализ в разрезе обязательств по каждой группе.',
    block13:
      'Ежедневный динамичный расчет финансовых коэффициентов поможет оценить текущее финансовое состояние.',
    block2: 'Синхронизация с банком',
    block21: 'Контролируй свои расходы',
    block22:
      'Посмотри на расходы с другой стороны – каждая необязательная трата отодвигает исполнение целей, найди свой баланс. Анализируй изменения внутри различных групп расходов в динамике. Результат позволит прогнозировать чистый денежный поток (разница текущих доходов и текущих расходов)',
    block3: 'Умные накопления',
    block31: 'Запиши цели и составь финансовый план',
    block32:
      'Создан положительный денежный поток (текущие доходы больше текущих расходов). Посмотри достаточно ли его для достижения финансовых целей. Все считается автоматически, но можно использовать ваши планы, занесенные вручную. Следи за динамикой выполнения финансового плана – вноси корректировки.',
    block41: 'Инвестируйте и достигайте своих целей',
    block42:
      'Робоэдвайзер whiteswan (белый лебедь) — персональные инвестиционные стратегии для достижения ваших финансовых целей',
    roboButton: 'Узнать больше',
    haveAdviser: 'Есть финансовый консультант?',
    shareLink:
      'Отправь ссылку на CRM блок для финансовых консультантов и работай с советником на единой платформе.',
    visit: 'Перейти на сайт',
    proposal: 'Ждем ваши предложения',
    company: 'ООО «ДАТА ТЕКНОЛОДЖИС ЭНД АНАЛИТИКС КОНСАЛТИНГ»',
    inn: 'ИНН: 7604323536, ОГРН: 1177627011836',
    agreement: 'Пользовательское соглашение',
    politic: 'Политика обработка данных',
  },
  auth: {
    register: 'Регистрация',
    enter: 'Вход',
    login: 'Войти',
    resendCode: 'Запросить код повторно через ',
    resendCodeButton: 'Запросить код',
    haveProfile: 'У вас есть аккаунт?',
    crm: 'CRM для финансовых консультантов',
    cancel: 'Отмена',
    forgotPassword: 'Забыли пароль',
    toRegister: 'Зарегистрироваться',
    promoCode: 'Промокод',
    password: 'Пароль',
    passwordRepeat: 'Повтор пароля',
    issue: (
      <>
        (напишите на <a href="mailto:info@whiteswan.finance">info@whiteswan.finance</a> если код не
        приходит)
      </>
    ),
    code: 'Код',
    codeAdvise: 'Введите код отправленный на',
    confirm: 'Подтвердить',
    fa: 'Код 2FA',
    createNewPassword: 'Придумайте новый пароль',
    newPassword: 'Новый пароль',
    newPasswordRepeat: 'Повтор нового пароля',
    save: 'Сохранить',
    restore: 'Восстановить',
  },
  config: {
    outcomes: 'Настройки категорий расходов',
    outcomes2:
      'Выберете категории для отображения на графиках. Также вы можете добавить свои категории.',
    outcomes3: 'Системные',
    outcomes4: 'Пользовательские',
    createCategory: 'Создать категорию',
    editCategory: 'Редактирование категории',
    incomes: 'Настройки категорий доходов',
    incomes2:
      'Выберете категории для отображения на графиках. Также вы можете добавить свои категории.',
    incomes3: 'Системные',
    incomes4: 'Пользовательские',
    name: 'Название',
    tags: 'Тэги',
    budgetTemplate: 'Шаблоны бюджетов',
    addCategory: 'Добавить категорию',
    add: 'Добавить',
    contactApp: 'Взаимодействие с приложением',
    zenmoney: 'Дзенмани',
    configBind:
      'Вы можете настроить связь для получения расходов и доходов, чтобы не добавлять эти данные вручную',
    addUser: 'Добавить пользователя',
    bind: 'Связать',
    unbind: 'Отвязать',
    tinkoff: 'Т-Инвестиции',
    configBindTinkoff:
      'Вы можете настроить связь для получения операций брокерского счета, чтобы не добавлять эти данные вручную.',
    bcs: 'БКС',
    configBindBcs:
      'Вы можете настроить связь для получения операций брокерского счета БКС, чтобы не добавлять эти данные вручную.',
    token: 'Токен',
    beginAgain: 'Начать все сначала',
    beginAgainText:
      'Если вы хотите пройти все шаги настройки приложения заново, нажимайте “Начать”. Все внесенные данные будут удалены.',
    bindAdvisorTitle: 'Привязать финансового советника',
    bindAdvisorDescription:
      'Введите имя и фамилию финансового советника (в таком порядке) или e-mail. Привязка выполнится только при полном совпадении.',
    bindAdvisorPlaceholder: 'Данные советника',
    bindAdvisorButton: 'Привязать',
    bindAdvisorSuccess: 'Финансовый советник успешно привязан.',
    bindAdvisorError: 'Не удалось привязать финансового советника. Проверьте фамилию.',
    bindAdvisorRequired: 'Введите фамилию полностью',
    bindAdvisorBound: 'Финансовый советник уже привязан.',
    bindAdvisorEmailLabel: 'Email финансового советника:',
    deleteAccount: 'Удалить счета',
    delete: 'Удалить',
    deleteAccountText: 'Удаляя счет, также будут удалены все связи с ним.',
    security: 'Настройка безопасности',
    securityGoogle: 'Вы можете настроить авторизацию с Google Authenticator',
    currencySaved: 'Валюта сохранена',
    languageSaved: 'Язык изменен',
    config: 'Настройка системы',
    mainCurrency: 'Основная валюта',
    enable2Fa: 'Включить 2FA',
    disable2Fa: 'Отключить 2FA',
    privateConfig: 'Настройка приватности',
    currentPassword: 'Текущий пароль',
    adminShow: 'Админу видны цифры в расходах',
    adminOperation:
      'Фин. советнику запрещено осуществлять операции с интегриррованного счёта Т-Инвестиции',
    language: 'Язык',
  },
  incomeOutcome: {
    outcome: 'Расходы',
    income: 'Доходы',
    addOutcome: 'Добавить расход',
    addIncome: 'Добавить доход',
    date: 'Дата',
    sum: 'Сумма',
    category: 'Категория',
    subcategory: 'Подкатегория',
    newSubcategory: 'Новая подкатегория',
    editSubcategory: 'Редактирование подкатегории',
    subcategoryName: 'Название',
    tag: 'Тэг',
    desc: 'Описание',
    buyAccount: 'Счет списания',
    sellAccount: 'Счет зачисления',
    unsetFilter: 'Сбросить фильтр',
    filter: 'Фильтр',
    addCategory: 'Добавить категорию',
    month: 'Месяц',
    period: 'Период',
    configCategory: 'Настроить категории',
    incomeOutcomePerPeriod: 'Доходы и расходы за период',
    monthes12: 'За 12 месяцев',
    byYear: 'По годам',
    configBudget: 'Настроить бюджеты',
    configBudget2: 'Настройка бюджета',
    overspend: 'У вас перерасход',
    leftBudget: 'В бюджете осталось',
    configTemplate: 'Настроить шаблоны',
    noBudgets: 'Нет созданных бюджетов',
    noBudgetForCategory: 'нет заполненного бюджета',
    create: 'Создать',
    select: 'Выбрать',
    countMoney: 'Количество денег на начало периода',
    incomes: 'Доходы',
    changeActives: 'Изменения активов личного пользования',
    invest: 'Инвестиционный поток',
    unconfirmedOperation: 'Неподтвержденные операции',
    selectTemplate: 'Выбор шаблона',
    templateWithoutName: 'Шаблон без названия',
    from: 'от',
    to: 'до',
    incomeTo: 'Поступления',
  },
  plan: {
    chartLife: 'График жизненного цикла',
    positiveScenario: 'Положительный',
    negativeScenario: 'Негативный',
    neutralScenario: 'Нейтральный',
    period: 'Период',
    positive: 'Положит.',
    neutral: 'Нейтральн.',
    negative: 'Негативный',
    middle: 'Среднее',
    tax: 'Налог',
    addIncome: 'Доп. доход',
    clear: 'Чистыми',
    outcome: 'Расходы',
    addOutcome: 'Доп. расход',
    obligations: 'Обязательства',
    goals: 'Цели',
    archiveGoals: 'Архив целей',
    diff: 'Остаток',
    probability: 'Вероятность',
    index: 'Индексация',
    inCarier: 'Во время карьеры',
    inRetire: 'На пенсии',
    ageRetire: 'Возраст выхода на пенсию',
    ageOnRetire: 'Сколько лет на пенсии',
    monthCarierStart: 'Месяц начала карьеры',
    extended: 'Подробно',
    short: 'Кратко',
    carier: 'Карьера',
    retire: 'Пенсия',
    monthPayment: 'Месяца выплат',
    allFor: 'Итого за ',
    year: 'г.',
    hands: 'На руки',
    contract: 'По договору',
    toAllPeriods: 'Распространить на следущие периоды',
    toAllPeriodsHint: 'Применяет настройки распространения на следующие годы (периоды).',
    reachGoal: 'Достижение цели',
    yes: 'Да',
    no: 'Нет',
    nameGoal: 'Название цели',
    countGoal: 'Количество выплат',
    startGoal: 'Дата начала накопления',
    endGoal: 'К какой дате',
    percentGoal: 'Размер ставки (годовых)',
    alreadySaved: 'Сколько уже отложено',
    inflationGoal: 'Размер инфляции (годовых)',
    closePayment: 'Ближайший платеж',
    retireAgePayment: 'Сколько лет выплачивать на пенсии',
    currentSpendPerYear: 'Текущий расход в год',
    periodPaymentGoal: 'Выберите период пополнения',
    createGoal: 'Создать цель',
    noCreatedGoals: 'Нет созданных целей',
    newGoal: 'Создание цели',
    editGoal: 'Редактирование цели',
    goalToolsMarkAchieved: 'Пометить как достигнутую',
    goalToolsArchive: 'Отправить в архив',
    goalToolsCloseGoal: 'Закрыть цель',
    goalArchiveModalTitle: 'Закрыть цель',
    goalArchiveChoiceText: 'Как закрыть цель?',
    goalArchiveAchievedQuestion: 'Достигнута ли цель?',
    goalArchiveAchievedQuestionWithName: 'Была ли цель «{name}» достигнута?',
    goalArchiveChoiceAchieved: 'Достигнута',
    goalArchiveChoiceNo: 'Нет',
    goalArchiveTransferTitle: 'Перенос активов',
    goalArchiveTransferText: 'Привязанные активы можно перенести в другую цель.',
    goalArchiveLinkedActives: 'Привязанные активы:',
    goalArchiveSelectGoal: 'Выберите цель',
    goalArchiveNoTransfer: 'Не переносить',
    sortGoal: 'Сортировка целей',
    finPlan: 'Финансовое планирование',
    priority: 'Приоритет целей',
    typeGoal: 'Тип цели',
    countPayment: 'Кол-во платежей',
    calcPayment: 'Расчёт ежемесячного платежа',
    futureValue: 'Будущая стоимость',
    tabChart: 'График',
    tabByGroups: 'По группам',
    scenario: 'Сценарий',
    shortGoal: 'Краткосрочная цель',
    middleGoal: 'Среднесрочная цель',
    longGoal: 'Долгосрочная цель',
    withBind: 'С привязкой',
    withoutBind: 'Без привязки',
    rentier: 'Рантье',
    rentierWithInflation: 'Рантье с инфляцией',
    retireFund: 'Пенсионный фонд',
    control: 'Учитывать',
    notControl: 'Не учитывать',
    goalsPriority: 'Приоритет целей',
    sumPayment: 'Сумма',
    datePayment: 'Дата',
    payment: 'выплаты',
    monthlyNotEqual: 'Ежемесячное превышение доходов над расходами',
    planPayments: 'Спланировано платежей',
    freeLeft: 'Свободный остаток',
    lessThan100: 'Сумма должна быть меньше 100',
    spreadToNextMonthes: 'Распространить на следующие месяцы',
    spreadToNextMonthesHint: 'Копирует текущие значения месяца на все следующие месяцы.',
    lockMainIncomeHint: 'Ручной режим: общая сумма считается по введенным месяцам.',
    lockAutoRecalcHint:
      'Автораспределение: измененный месяц фиксируется, остальные месяцы пересчитываются автоматически.',
    spreadUserDefined: 'Пользовательское',
    spreadEqual: 'Поровну',
    planAsset: 'Актив',
    planSelectAsset: 'Выбрать актив',
    planPercent: 'Процент',
    planDistribution: 'Распределение',
    planTag: 'Тэг',
  },
  goalItems: {
    columnAsset: 'Актив',
    columnQuantity: 'Кол-во',
    columnValuation: 'Оценка',
    columnDate: 'Дата',
    columnSum: 'Сумма',
    columnAccount: 'Счёт',
    columnBalance: 'Баланс',
    editTitle: 'Редактирование элемента цели',
    newTitle: 'Новый элемент цели',
    accounts: 'Счета',
    sumLabel: 'Сумма',
    noAccounts: 'Нет доступных счетов',
    selectOneError: 'Выберите хотя бы один актив или счёт',
    error: 'Ошибка',
  },
  invest: {
    stats: 'Статистика',
    currentPriceActives: 'Текущая стоимость активов',
    avgPriceActives: 'Средняя стоимость активов',
    profitPerPeriod: 'Доходность за период',
    expectedProfit: 'Ожидаемая доходность',
    profitYear: 'Доходность годовая',
    maxLose: 'Максимальная просадка',
    koefSharp: 'Коэффициент Шарпа',
    koefSortino: 'Коэффициент Сортино',
    byGroup: 'По группе',
    byType: 'По типу',
    byAccount: 'По счёту',
    value: 'Стоимость портфеля',
    term: 'Срок',
    period: 'Период',
    portfolio: 'Портфель',
    div: 'Дивиденды',
    coupons: 'Купонные выплаты',
    invest: 'Список инвестиций',
    archiveInvest: 'Архив сделок',
    addInvest: 'Добавить фин. актив',
    buySellActive: 'Покупка / Продажа фин. актива',
    more: 'Еще',
    replaceActive: 'Замена актива',
    transferSecurities: 'Перевод бумаг',
    transferSecuritiesApi: 'Перевод бумаг на API с заменой',
    filter: 'Фильтр',
    repo: 'РЕПО',
    repoClose: 'Закрыть РЕПО',
    priceWithDiscount: 'Цена с учетом дисконта',
    direct: 'Прямой',
    reverse: 'Обратный',
    securitiesInLot: 'Бумаг в 1 лоте',
    currentSecuritiesCount: 'Текущее кол-во бумаг',
    openedQuantity: 'Количество лотов для блокировки',
    closedQuantity: 'Количество для разблокировки',
    repoCostPercent: 'Процентная ставка',
    discount: 'Дисконт %',
    commissionSum: 'Сумма комиссии за РЕПО',
    repoOpeningDate: 'Дата открытия РЕПО',
    repoCloseDate: 'Дата закрытия сделки РЕПО',
    repoCloseCalculateDate: 'Дата закрытия расчетов РЕПО',
    repoCalculateDate: 'Дата расчетов',
    amount: 'Сумма',
    calculatedFee: 'Расчетная плата',
    repoPayment: 'Оплата за РЕПО',
    asset: 'Актив',
    paper: 'Бумага',
    activeAccount: 'Счет где хранится бумага',
    storageAccount: 'Счет хранения',
    toAccount: 'Счет зачисления',
    toCurrency: 'Валюта зачисления средств',
    currency: 'Валюта',
    fromAccount: 'Счет списания',
    fromCurrency: 'Валюта списания комиссии',
    repoCommissionSum: 'Сумма сделки',
    repoDealNumber: 'Номер сделки РЕПО',
    repoDealNumberBroker: 'Номер сделки репо по брокерскому отчету',
    blockedQuantity: 'Кол-во заблок.',
    unblockedQuantity: 'Кол-во разблок.',
    ratePercent: 'Ставка %',
    close: 'Закрыть',
    portfolioClass: 'Класс',
    totalQuantity: 'Кол-во всего',
    sharePercent: 'Доля %',
    valuation: 'Стоимость',
    // Переводы для колонок таблицы REPO (без слова "РЕПО")
    tableOpeningDate: 'Дата открытия',
    tableCalculateDate: 'Дата расчетов',
    tableCloseDate: 'Дата закрытия сделки',
    tableCloseCalculateDate: 'Дата закрытия расчетов',
    tableDealSum: 'Сумма сделки',
    /** Колонки таблицы /investing/repos: суммы в валюте сделки, без пересчёта по валюте кабинета */
    repoTableAmount: 'Сумма (вал. сделки)',
    repoTableDealSum: 'Сумма сделки (вал. сделки)',
    reposOperationSum: 'РЕПО: сумма сделок',
    reposCommissionSum: 'РЕПО: комиссии',
    reposTotalInCurrency: ' (итого {currency})',
    tradeRepoLockTitle: 'Сделка в РЕПО',
    tradeRepoLockDescription:
      'Сохранить изменения нельзя: бумаги заблокированы до закрытия операции РЕПО.',
    diagrams: {
      tabActive: 'Актив',
      tabGroupAssets: 'Группа активов',
      typeActive: 'Актив',
      typeGroupAssets: 'Группа активов',
    },
    case: {
      exportLoading: 'Загрузка файла',
    },
  },
  clientsPage: {
    tabClient: 'Клиент',
    tabDemo: 'Демо',
  },
  profile: {
    profile: 'Профиль',
    photo: 'Фото',
    enterName: 'Введите имя',
    enterEmail: 'Введите email',
    enterSurname: 'Введите фамилию',
    enterPhone: 'Введите телефон',
    enterMiddlename: 'Введите отчество',
    enterBirthDate: 'Дата рождения',
    enterStartDate: 'Дата внесения информации об активах',
    tutorial: 'Пройдите определенные шаги настройки приложения',
    start: 'Начать',
    begin: 'Начало',
    tutorial1: 'Модуль бюджет',
    tutorial2: 'Модуль список<br/> инвестиций',
    tutorial3: 'Модуль планирования',
    tutorial4: 'Заполнение счетов, активов',
    tutorial5: 'Пройти обучение',
    finish: 'Завершить обучение',
    next: 'Далее',
    lesson1: {
      page1: 'Страница профиль, необходимо заполнить обязательные поля и нажать кнопку "Сохранить"',
      page2: 'Окно "Благостояниеие" показывает сводную информацию по вашим финансам',
      page3: 'Для перехода на главный дашборд, нажмите.',
      page4: 'На этом дашборде будет ваша текущая финансовая ситуация',
      page5: 'Выберите в меню раздел "Счета / Активы / Обязательства"',
      page6: 'Блок "Счета" содержит информацию о всех остатках',
      page7: 'Для создания счёта, необходимо нажать кнопку "Создать счёт"',
      page8: 'Форма создания нового счёта',
      page9:
        'Назовите новый счет, например "Сбер_зарплата".\nНе рекомендуем  писать просто название банка , так как в нем может быть несколько счетов, или счета вашего струга/партнера с кем вы совместно ведете финансовый учет.',
      page10:
        'Выберите тип счета. Каждый тип обладает своей логикой. Если не знаете наверняка - выбирайте пользовательский тип счета.',
      page11: 'Придумайте название субсчета, например "Зарплата".',
      page12: 'Выведите текущий баланс по счету.',
      page13: 'Выберите валюту.',
      page14: 'Внесите несколько счетов в одном банке, например, есть счета в разных валютах.',
      page15:
        'Обратите внимание депозиты для банковских счетов офорляются отдельно от текущих счетов.',
      page16: 'После окончания заполнения показываем счета.',
      page17: 'Заполните форму и сохраниет счета',
      page18: 'Теперь вы видите свои счета и остатки денег на них',
      page19: 'Обучение завершено',
    },
    fillForm: 'Заполните персональные данные',
  },
  roboLanding: {
    hero: {
      title: 'Инвестируйте и достигайте своих целей',
      subtitle:
        'Робоэдвайзер whiteswan (белый лебедь) — персональные инвестиционные стратегии для достижения ваших финансовых целей',
      button: 'Начать инвестировать',
    },
    utp: {
      title: 'Удобное инвестирование по финансовому плану whiteswan (белый лебедь)',
      subtitle: 'Рыночная доходность с минимальным риском. Инвестиции от 100 рублей',
      card1Title: 'Минимальный риск',
      card1Text: 'Исторически выше инфляции и средних рублёвых вкладов',
      card2Title: 'От 100 рублей',
      card2Text: 'Можно начать с минимальной суммы, рекомендуем от 300 000 ₽',
      card3Title: 'Персонализация',
      card3Text: 'Стратегия строится под ваши финансовые цели и сроки',
      disclaimer:
        '*Доходность в прошлом не гарантирует доходность в будущем. Инвестиции связаны с риском потерь.',
    },
    strategy: {
      title: 'Ваша персональная стратегия ',
      subtitle: 'Поможет вам достигать финансовые цели',
      descriptionTitle: 'Описание:',
      item1: 'Доходность ориентир: 17% годовых*',
      item2: 'Исторически выше инфляции и средних рублёвых вкладов',
      item3: 'Состав: акции, облигации и золото РФ',
      item4: 'Уровень риска: Низкий–Средний',
      disclaimer:
        '*Доходность в прошлом не гарантирует доходность в будущем. Инвестиции связаны с риском потерь.',
      suitableTitle: 'Подходит именно вам:',
      suitableText:
        'Подстраивается под ваши цели;<br />Учитывает вашу склонность к риску;<br />Учитывает ваши доходы и расходы.',
    },
    howItWorks: {
      title: 'Начните инвестировать в своё будущее',
      subtitle: 'Это проще, чем кажется',
      step1Title: 'Скачайте приложение',
      step1Text: 'Установите whiteswan (белый лебедь) на iOS или Android.',
      step2Title: 'Заполните свой финансовый план',
      step2Text:
        'Укажите: финансовые цели (квартира, подушка, образование, пенсия и т.д.), сумму и срок, доходы, активы и обязательства. Это нужно, чтобы стратегия строилась под вашу реальную жизнь, а не только под баланс одного счёта.',
      step3Title: 'Пройдите короткий опрос',
      step3Text:
        'Мы оцениваем вашу реальную склонность к риску, а не «для галочки», как в формальных анкетах у брокеров: учитываем доходы, обязательства, опыт и то, как вы относитесь к резким движениям цен на рынке.',
      step4Title: 'Подключите счёт в Т-Инвестициях',
      step4Text:
        'Выберите один из вариантов: использовать текущий брокерский счёт или открыть отдельный счёт специально под робоэдвайзер whiteswan (белый лебедь). Если на выбранном счёте уже есть активы, которые не подходят под вашу цель, алгоритм продаст их и соберёт портфель под стратегию. Если у вас ещё нет счёта в Т-Инвестициях — вы сможете открыть его прямо в процессе, это займёт немного времени.',
      step5Title: 'Получите токен в Т-Инвестициях',
      step5Text:
        'Токен нужен, чтобы робоэдвайзер whiteswan (белый лебедь) мог читать данные счёта и передавать торговые поручения — без доступа к деньгам. Как получить токен: Откройте приложение Т-Инвестиции → Перейдите в раздел Настройки → Доступ для приложений / API → Создайте новый токен → Выберите доступ: просмотр счёта, совершение сделок (без доступа к выводу средств) → Скопируйте токен',
      step6Title: 'Введите токен в приложении whiteswan (белый лебедь)',
      step6Text:
        'После этого робоэдвайзер whiteswan (белый лебедь): подберёт стратегию под ваш профиль, соберёт портфель под ваши цели, следит за ним и постепенно снижает риски, когда цель приближается.',
      safetyTitle: 'Это безопасно',
      safetyItem1: 'Робоэдвайзер whiteswan (белый лебедь) не имеет доступа к выводу средств;',
      safetyItem2: 'Деньги и активы всегда остаются на вашем брокерском счёте;',
      safetyItem3:
        'Вы в любой момент можете: пополнить или вывести деньги, изменить цель, отключить робоэдвайзер и управлять портфелем самостоятельно.',
    },
    benefits: {
      title: 'Робоэдвайзер whiteswan (белый лебедь) лучше частных консультантов',
      subtitle: 'Первые 3 месяца бесплатно',
      benefit1Title: 'Персонализация под ваши цели',
      benefit1Text:
        'Стратегия строится из вашего финплана: учитываются доходы, активы, долги и сроки целей — ничего лишнего.',
      benefit2Title: 'Первые 3 месяца бесплатно',
      benefit2Text:
        'Проходите опросники внутри сервиса, получайте баллы и тратьте их на робоэдвайзер.',
      benefit3Title: 'Старт без барьеров',
      benefit3Text:
        'Можно начать от 100 ₽. Рекомендуем от 300 000 ₽ для более эффективного формирования портфелей. При таких портфелях будет доступен весь спектр бумаг, даже с большими лотами.',
      benefit4Title: 'Алгоритмы вместо эмоций',
      benefit4Text:
        'Решения принимаются моделью заранее — никакой паники, только чёткий план под вашу реальную жизнь.',
      benefit5Title: 'Полная свобода действий',
      benefit5Text:
        'В любой момент пополнить, вывести, сменить цель или отключить робоэдвайзер whiteswan (белый лебедь) без потери % (в отличии от депозитов).',
      benefit6Title: 'Поддержка',
      benefit6Text: 'Команда поддержки готова помочь с любыми вопросами по использованию сервиса.',
      button: 'Начать бесплатно инвестировать',
    },
    faq: {
      title: 'FAQ',
      subtitle: 'если остались вопросы',
      question1: 'Чем whiteswan (белый лебедь) отличается от обычного брокера?',
      answer1:
        'whiteswan (белый лебедь) — это робоэдвайзер, а не брокер. Брокер даёт доступ к рынку, а whiteswan (белый лебедь) помогает сформулировать финансовые цели, подбирает инвестиционную стратегию под них, автоматически управляет портфелем по заранее заданной логике. Все активы при этом остаются на вашем брокерском счёте.',
      question2: 'Я новичок. Мне подойдёт whiteswan (белый лебедь)?',
      answer2:
        'Да. whiteswan (белый лебедь) создавался в том числе для людей без финансового образования, без времени на самостоятельный выбор активов, которым важно инвестировать под цели, а не разбираться в рынках. Приложение само подсказывает шаги и объясняет логику решений простым языком.',
      question3: 'Что будет, если рынок упадёт?',
      answer3:
        'Просадки — нормальная часть инвестирования. Робоэдвайзер whiteswan (белый лебедь) заранее учитывает вашу склонность к риску, подбирает стратегию под срок цели, постепенно снижает риск по мере его приближения. Это снижает вероятность резких решений на эмоциях, но не отменяет резкие движения цен на рынке.',
      question4: 'Почему нужен доступ через токен? Это точно безопасно?',
      answer4:
        'Токен — это стандартный способ подключения инвестиционных сервисов. Он позволяет читать данные счёта, передавать торговые поручения. Токен не даёт доступ к выводу средств, деньги остаются на вашем брокерском счёте, токен можно отозвать в любой момент в Т-Инвестициях.',
      question5: 'Можно ли инвестировать сразу под несколько целей?',
      answer5:
        'Да. Вы можете создать несколько целей, подключить отдельные стратегии, распределить деньги под разные сроки и задачи. Это удобно, если у вас есть, например, подушка безопасности и долгосрочная цель одновременно.',
      question6: 'Тарифы',
      answer6:
        'Первые 3 месяца бесплатно. Проходите опросники внутри сервиса, получайте баллы и тратьте их на робоэдвайзер.',
      question7: 'Как отключить',
      answer7:
        'Отключить стратегию можно в любой момент, нажав «Отключить» в карточке стратегии. Это займёт 3 минуты.',
      question8: 'Зачем мне цели',
      answer8:
        'Стратегия становится эффективнее и персонализированной, когда вы подключаете свою финансовую цель и проходите опросник. Стратегия проводит ребалансировку под ваш тип личности и приближения к дате финансовой цели.',
    },
    finalCta: {
      title:
        'Установите whiteswan (белый лебедь) Finance на свой смартфон и получите бесплатный доступ к финансовому планировщику и персонализированному робоэдвайзеру',
      subtitle: 'Начать планировать будущее',
      downloadIos: 'Скачать для iOS',
      downloadAndroid: 'Скачать для Android',
    },
  },
  instruction: {
    next: 'Далее',
    openAccount: 'Открыть счёт',
    close: 'Закрыть',
    ok: 'Ок',
    brokerAccounts: 'Брокерские счета',
    accountIntro1:
      'Открывая брокерские счета через нас вы получаете часть комиссий назад и сможет потратить ее на платные услуги сервиса. ',
    accountIntro2:
      'Так же, чем больше клиентов откроет счета тем больше шанс ускорить процесс автоматического переноса данных от брокера в ваш личный кабинет whiteswan (белый лебедь).',
    iisNotice:
      'Если ИИС уже открыт, например, у другого брокера или управляющей компании, то «галочку» для открытия ИИС ставить не следует. Физическое лицо по закону может иметь только один ИИС.',
    smsCodeNotice: 'Далее приходит СМС-код для подтверждения процесса открытия счета. ',
    bks: {
      title: 'Инструкция по открытию брокерского счета в БКС',
      stepOf: 'Шаг %1 из %2',
      step1p1:
        'Для открытия брокерского счета потребуется номер личного мобильного телефона.  Одновременно же можно открыть индивидуальный инвестиционный счет (ИИС).',
      step2p1: 'Выбрать ручной ввод персональных данных или электронное распознавание фото/сканов',
      step2p2:
        'После ввода персональных данных или загрузки фото/сканов происходит их проверка в течение 1-2 минут.',
      step3p1: 'Необходимо сверить персональные данные и «ПРОДОЛЖИТЬ»',
      step4p1:
        'После получения СМС «Документы проверенны» для продолжения процесса открытия счета нажмите «Мне пришло СМС».',
      step5p1:
        'Затем подписываете сформированный комплект документов. Нажатьна кнопку «ПОДПИСАТЬ». Придет СМС-код.',
      step5p2:
        'Приложени «БКС Мир инвестициий» будет доступно сразу же после прихода временного пароля, завод активов на счет тоже доступен сразу.',
    },
    aton: {
      title: 'Инструкция по открытию брокерского счета в АТОН',
      stepOf: 'Шаг %1 из %2',
      step1p1:
        'Для открытия брокерского счета потребуется номер личного мобильного телефона.  Одновременно же можно открыть индивидуальный инвестиционный счет (ИИС).',
      step2p1: 'Выбрать ручной ввод персональных данных или с помощью «Госуслуг»',
      step3p1: 'После ввода персональных данных необходимо заполнить данные адреса',
      step4p1:
        'В разделе Дополнительные сведения «галочки». В большинстве случаев они не отмечаются.  Индивидуально. ',
      step5p1:
        'Затем документы формируются  и приходит уведомление о готовности для проверки и подтверждения СМС-кодом.',
      step5p2:
        'Приложени «АТОN line» будет доступно сразу же после прихода временного пароля, завод активов на счет тоже доступен сразу.',
    },
    tinkoff: {
      title: 'Инструкция по открытию брокерского счета в Т-Банке',
      stepOf: 'Шаг %1 из %2',
      step1p1:
        'Для открытия брокерского счета вам потребуется ввести персональные данные — ФИО полностью и номер телефона в заявке на сайте банка.',
      step2p1:
        'Ввести паспортные данные: Серия и номер паспорта, дату рождения, адрес регистрации. А также электронную почту.',
      step3p1: 'Необходимо подтвердить заявку по СМС и ждать сообщения об открытии счета.',
    },
    tinkoffToken: {
      title: 'Инструкция по синхронизации с Т-Инвестиции',
      stepOf: 'Шаг %1 из %2',
      step1p1:
        'Чтобы связать аккаунт Т-Инвестиции с whiteswan.finance (белый лебедь) для автоматизации загрузки ваших инвестиций, необходимо выпустить токен.',
      step1p2before: 'Для этого: Перейдите в настройки профиля Т-Инвестиции по ссылке: ',
      step1p2url: 'https://www.tbank.ru/invest/settings/api/',
      step1p2after: ' Авторизуйтесь в системе, если это требуется.',
      step2p1:
        'Выпустите токен Т-Инвестиции API в блоке "Создание токена". Выберите счет, который вы хотите привязать и выбери пункт "Только для чтения"*.',
      step2p2:
        '*Только для чтения — данный тип токена предназначен только для получения различной информации, такой как состояние портфеля, расписание торгов различных торговых площадок, текущие котировки, исторические данные и т.п. С данным типом токена невозможно выставление торговых поручений.',
      step2p3:
        'Возможно, система попросит вас авторизоваться еще раз. Не беспокойтесь, это необходимо для подключения робота к торговой платформе.',
      step3p1: 'Скопируйте токен и вставьте его в соответствующее поле в настройках профиля.',
      step3p2:
        'Токен отображается только один раз, просмотреть его позже не получится. Тем не менее вы можете выпускать неограниченное количество токенов.',
      step4p1: 'Портфель в Т-Инвестиции успешно привязан к вашему аккаунту.',
    },
    zenMoney: {
      title: 'Инструкция по синхронизации с Дзен.мани',
      stepOf: 'Шаг %1 из %2',
      step1p1:
        'Перед тем как связать Дзен.мани с whiteswan (белый лебедь) рекомендуем вам скачать приложение Дзен.мани на свой телефон и добавить туда ваши счета.',
      step1p2: 'Дзен.мани в AppStore: ',
      step1p3: 'Дзен.Мани в GooglePlay: ',
      step2p1:
        'Чтобы связать аккаунт Дзен.мани с whiteswan.finance (белый лебедь) для автоматизации загрузки ваших доходов и расходов, необходимо: Нажать "Связать" в настройках профиля.',
      step3p1: 'Войти в свой аккаунт Дзен.мани.',
    },
  },
};
